import {useUserContext} from './UserContextProvider'

/**
 * hook to get the loggedUser from UserContext
 * use in components where loggedUser is required
 * @returns User object from UserContext
 */
export const useRequiredUser = () => {
  const {loggedUser} = useUserContext()
  if (!loggedUser) {
    throw new Error('BUG: User data is required but not available in UserContext')
  }
  return loggedUser
}
